import React, { Component } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import _ from "underscore";

export default class Row extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsClass: "hidden",
      expanded: false,
      showDetailsWasCalled: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.keyValue !== nextProps.keyValue &&
      this.state.showDetailsWasCalled
    )
      if (this.props.showDetailsFun) this.props.showDetailsFun(nextProps.item);
  }

  render() {
    let {
      tables,
      tableKey,
      widthContainer,
      scrollProgress,
      detailsRenderer,
      selectId,
      item,
    } = this.props;

    let columns = tables[tableKey].columns;
    let selections = tables[tableKey].selections;
    let showDetails = !!detailsRenderer;
    let allowSelections = !!selectId;

    let renderColumns = _.filter(columns, (col) => {
      return col.visible === true;
    });

    let detailsTemplate;
    if (showDetails && this.state.expanded) {
      let detailsStyle = {
        width: widthContainer ? widthContainer.clientWidth + "px" : "auto",
        marginLeft: scrollProgress ? scrollProgress - 2 + "px" : "0",
        padding: "5px",
      };

      detailsTemplate = (
        <tr className={this.state.detailsClass}>
          <td colSpan={renderColumns.length + 1}>
            {
              // eslint-disable-next-line react/no-string-refs
              <div style={detailsStyle} ref="container">
                {detailsRenderer(item, this.state.expanded)}
              </div>
            }
          </td>
        </tr>
      );
    }

    let selcetionColumn;
    if (allowSelections) {
      let isSelected = selections[item[selectId]];

      selcetionColumn = (
        <td>
          <Checkbox
            checked={!!isSelected}
            onClick={this.props.selectRowFunc.bind(
              this,
              item[selectId],
              !isSelected,
              tableKey,
            )}
          />
        </td>
      );
    }

    let showDetailsButtonColumn;
    if (showDetails)
      showDetailsButtonColumn = (
        <td onClick={this.switchDetails}>
          {this.state.expanded ? "Collapse" : "Expand"}
        </td>
      );

    let additionalBgColor = item.bgColor
      ? { backgroundColor: item.bgColor }
      : {};
    return (
      <tbody>
        <tr
          className={"pointer " + this.props.className}
          style={additionalBgColor}
        >
          {selcetionColumn}
          {showDetailsButtonColumn}
          {renderColumns.map((column, index) => {
            return (
              <TableCell
                {...this.props}
                key={index + tableKey}
                column={column}
                item={item}
              />
            );
          })}
        </tr>
        {detailsTemplate}
      </tbody>
    );
  }

  switchDetails = () => {
    let expanded,
      detailsClass,
      showDetailsWasCalled = this.state.showDetailsWasCalled;
    if (this.state.expanded) {
      detailsClass = "hidden";
      expanded = false;
    } else {
      detailsClass = "visible";
      expanded = true;

      // for first expand
      if (this.props.showDetailsFun && !this.state.showDetailsWasCalled) {
        this.props.showDetailsFun(this.props.item);
        showDetailsWasCalled = true;
      }
    }

    this.setState({
      detailsClass,
      expanded,
      showDetailsWasCalled,
    });
  };
}

const TableCell = ({ column, item, actionColumnWidth, ...props }) => {
  let fieldVal;
  let getValueFunc;
  let keys = column.key.split(".");
  actionColumnWidth = actionColumnWidth ? actionColumnWidth : "200px";

  if (keys.length === 2) getValueFunc = getValue2;
  else if (keys.length === 1) {
    getValueFunc = getValue;
    keys.push("");
  }

  fieldVal = getValueFunc(item, keys[0], keys[1]);
  let content;
  if (column.renderer) content = column.renderer(fieldVal, item, props);
  else if (fieldVal === false) content = "No";
  else if (fieldVal === true) content = "Yes";
  else if (fieldVal === 0) content = "0";
  else if (fieldVal) content = fieldVal ? fieldVal.toString() : undefined;

  let cellClass = "table-cell";
  let contentClass = "";
  let actionStyle = {};
  if (column.label === "Actions") {
    cellClass = "action-cell";
    contentClass = "action-cell__content";
    actionStyle = { width: actionColumnWidth };
    return (
      <React.Fragment>
        <td className="table-cell" style={actionStyle}>
          <div className={contentClass}> {content} </div>
        </td>
        <td className={cellClass} style={actionStyle}>
          <div className={contentClass}> {content} </div>
        </td>
      </React.Fragment>
    );
  }

  return (
    <td className={cellClass} style={actionStyle}>
      <div className={contentClass}> {content} </div>
    </td>
  );
};

function getValue(object, key1) {
  return object[key1];
}

function getValue2(object, key1, key2) {
  const val = getValue(object, key1);
  return val ? getValue(val, key2) : undefined;
}
